module.exports = new __parcel__URL__("report-time-since.657aa64d.svg").toString();